import React from "react"

const FullPageLoader = ({ 
  show = false, 
  message = "",
  backgroundColor = "rgba(0, 0, 0, 0.3)",
  zIndex = 1002
}) => {
  if (!show) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: backgroundColor,
        backdropFilter: "blur(4px)",
        webkitBackdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: zIndex,
      }}
    >
      <div
        style={{
          color: "#fff",
          fontSize: "16px",
          fontWeight: "500",
          textShadow: "0 1px 3px rgba(0,0,0,0.3)",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <span
          className="spinner-border"
          role="status"
          aria-hidden="true"
        ></span>
        {message && <span>{message}</span>}
      </div>
    </div>
  )
}

export default FullPageLoader